import {AccountsList} from './AccountsList'


export default {
  list: <AccountsList />
}
